import DayOfWeek from 'owa-service/lib/contract/DayOfWeek';
import { action } from 'satcheljs';

/**
 * action for mutating the activeViewState in options store when the week start option is changed along with side effects if any
 * @param newWeekStart - the new value for the week start
 * public action
 */
const changeWeekStartOption = action('changeWeekStartOption', (newWeekStart: DayOfWeek) => ({
    newWeekStart,
}));

export default changeWeekStartOption;
